import React from "react";
import { motion } from "framer-motion";
import { SelectItemProps } from "./Select.props";
import P from "../P/P";
import SvgIcon from "../SvgIcon/SvgIcon";
import { CheckIcon } from "@assets/icons";

const SelectItem: React.FC<SelectItemProps> = ({
	item,
	onSelect,
	selected,
	itemClassName = "",
}) => {
	return (
		<motion.li
			className={`grid px-3.5 py-2 cursor-pointer rounded-lg transition-colors duration-200 ${
				selected
					? "bg-light-shadeOne dark:bg-dark-shadeOne text-light-textColor dark:text-dark-textColor grid-cols-maxTwo place-items-center place-content-between"
					: "bg-light-bgColor dark:bg-dark-bgColor text-light-textColor dark:text-dark-textColor grid-cols-1"
			} hover:bg-light-grayOne dark:bg-dark-grayOne ${itemClassName}`}
			onClick={() => onSelect(item)}
			role="option"
			aria-selected={selected}
		>
			<P
				size="t1"
				type="regular"
				className="cursor-pointer text-light-textColor dark:text-dark-textColor"
			>
				{item.label}
			</P>
			{selected && (
				<SvgIcon
					Icon={CheckIcon}
					className="w-5 h-5 stroke-light-mainColor dark:stroke-dark-mainColor"
				/>
			)}
		</motion.li>
	);
};

export default React.memo(SelectItem);
